import { type ReactNode, Suspense } from 'react';
import { DefaultFallback } from '../layout/DefaultFallback';
import { DeferredComponent } from '../util/DeferredComponent';

import { ErrorResetBoundary } from './ErrorResetBoundary';

interface ListBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

export const ListBoundary = ({ children, fallback }: ListBoundaryProps) => (
  <ErrorResetBoundary>
    <Suspense
      fallback={
        fallback ?? (
          <DeferredComponent>
            <DefaultFallback mih={370} />
          </DeferredComponent>
        )
      }
    >
      {children}
    </Suspense>
  </ErrorResetBoundary>
);
